import { Component, OnInit } from '@angular/core';
import { Payload } from '@app/flight-planning/flight-plan-constant';
import { FlightPlanService } from '@app/flight-planning/route-plan/services/flight-plan.service';
import { Events } from '@app/shared/services/events.service';
@Component({
    selector: 'app-payload',
    templateUrl: './payload.component.html',
    styleUrls: ['./payload.component.scss'],
    standalone: false
})
export class PayloadComponent implements OnInit {
  public payload = new Payload();
  constructor(public flightPlanService: FlightPlanService, private events: Events,) {
    this.payload = this.flightPlanService.payload;
  }

  public ngOnInit() { }
  public ngAfterViewInit() { }
  public openAccordian() {
    this.flightPlanService.accordionSwitch('payload');
  }
  public emitEvent(event:any) {
    this.events.publish(
      "payloadOnInput",
      event
    );
  }
}
